"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OfferCreateOrEdit = OfferCreateOrEdit;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_scroll_1 = require("react-scroll");
const types_1 = require("@src/types");
const elements_1 = require("@src/components/elements");
const OfferStepsOverview_1 = require("./offer-steps/OfferStepsOverview");
const offer_context_1 = require("./offer-context");
const OfferSteps_1 = require("./offer-steps/OfferSteps");
function OfferCreateOrEdit({ offerAction }) {
    const [currentOfferStep, setCurrentOfferStep] = react_1.default.useState(types_1.EOfferStep.PAYMENT_TYPE);
    const goToOfferStep = (offerStep) => {
        setCurrentOfferStep(offerStep);
        react_scroll_1.animateScroll.scrollToTop();
    };
    return ((0, jsx_runtime_1.jsx)(offer_context_1.OfferContextProvider, { offerAction: offerAction, children: (0, jsx_runtime_1.jsxs)(elements_1.Panel, { children: [(0, jsx_runtime_1.jsx)(OfferStepsOverview_1.OfferStepsOverview, { currentOfferStep: currentOfferStep }), (0, jsx_runtime_1.jsx)(OfferSteps_1.OfferSteps, { currentOfferStep: currentOfferStep, goToStepPaymentType: () => goToOfferStep(types_1.EOfferStep.PAYMENT_TYPE), goToStepPreview: () => goToOfferStep(types_1.EOfferStep.PREVIEW), goToStepBasicInfo: () => goToOfferStep(types_1.EOfferStep.BASIC_INFO), goToStepAssets: () => goToOfferStep(types_1.EOfferStep.ASSETS) })] }) }));
}
